import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import DramasPage from "@/pages/dramas/page";
import DramaDetailPage from "@/pages/drama/page";
import AboutPage from "@/pages/about/page";
import FaqPage from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "dramas",
        element: <DramasPage />,
      },
      {
        path: "drama/:id",
        element: <DramaDetailPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "faq",
        element: <FaqPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;